export default __webpack_public_path__ + "static/media/family.c16a6612.jpg";